import React from 'react';

import styles from "../styles/entity-mega-header-module.module.scss";
import classNames from "classnames";
import {EntityLogo} from "../../../../../core/components/logos/entity-logo";
import {Link} from "../../../../../core/components/link/link";

export const EntityMegaHeaderModuleLogo = ({controller, entity}) => {
  const {device} = controller;
  const {isSmallView} = device;

  const linkProps = {
    className: classNames(styles.logo_container),
    model: entity.linkModel
  }

  const logoProps = {
    width: isSmallView ? 24 : 64,
    height: isSmallView ? 24 : 64,
    className: classNames(styles.logo),
    entity
  }

  return (
    <Link {...linkProps}>
      <EntityLogo {...logoProps}/>
    </Link>
  )
};
